import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteEmitenteCadastro } from '../service';
import {
  DELETE_EMITENTE_CADASTRO,
  DELETE_EMITENTE_CADASTRO_PENDING,
  DELETE_EMITENTE_CADASTRO_SUCCESS,
  DELETE_EMITENTE_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteEmitenteCadastro(action) {
  yield put({ type: DELETE_EMITENTE_CADASTRO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.INSCRICAO_FISCAL_EXCLUIR);

  try {
    const a = yield call(deleteEmitenteCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_EMITENTE_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {
    yield put({ type: DELETE_EMITENTE_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Verifique se o emitente não está vinculado em outra movimentação no sistema...');
  }
}

export default function* watchDeleteEmitenteCadastro() {
  yield takeLatest(DELETE_EMITENTE_CADASTRO, sagaDeleteEmitenteCadastro)
}
